export class FileImportTryResponse {
  type: string;
  fields: { [key: string]: string };
  animals: FileImportTryAnimal[];
  exist: boolean;
  preview?: FileImportTryPreview;
}

export class FileImportTryPreview {
  created?: number;
  updated?: number;
  unchanged?: number;
  on_order?: number;
  [key: string]: number | string | undefined;
}

export class FileImportTryAnimalChange {
  old: string | number | boolean | null;
  new: string | number | boolean | null;
}

export class FileImportTryVionOrder {
  id: number;
  order_number: string | null;
  status: string | null;
}

export type FileImportDetectConfidence = 'high' | 'medium' | 'low';

export interface FileImportDetectCandidate {
  key: string;
  label: string;
  score: number;
  confidence: FileImportDetectConfidence;
  confidence_reason?: string;
  reasons?: string[];
  signals?: { [key: string]: string | number | boolean | null };
}

export interface FileImportDetectResponse {
  candidates: FileImportDetectCandidate[];
  best_match: string | null;
  debug?: { [key: string]: string | number | boolean | null };
}

export class FileImportTryAnimal {
  country_code: string;
  identification_number: string;
  error: string;
  fields: { [key: string]: string };
  exist: boolean;
  action?: 'create' | 'update' | 'unchanged';
  changes?: { [key: string]: FileImportTryAnimalChange };
  vion_order?: FileImportTryVionOrder | null;
}
